// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WOd9","rootMobile":"styles_rootMobile__2t6MN"};